/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Lazy loading of the component PageExpensesAnalyzer
 *
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.1.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PageExpensesAnalyzer" */ './PageExpensesAnalyzer'), undefined);

